// All backend calls used by the exercise-template builder, in one place -
// mirrors the shape of conversations-creator-canvas/api.js. Note the field
// naming is inconsistent on the backend itself: ExerciseTemplateElement and
// ExerciseTemplateInteractiveElement use "exercise", ExerciseTemplateWord
// uses "exerciseTemplate" - both filter via ?exercise= regardless.

import axios from 'axios';

const jsonHeaders = {
    withCredentials: true,
    headers: {
        'Content-Type': 'application/json',
    },
};

// --- ExerciseTemplate ---

export function getExerciseTemplates() {
    return axios.get('/api/exercisetemplates', { withCredentials: true });
}

export function getExerciseTemplate(id) {
    return axios.get('/api/exercisetemplates/' + id, { withCredentials: true });
}

export function createExerciseTemplate(payload) {
    return axios.post('/api/exercisetemplates', JSON.stringify(payload), jsonHeaders);
}

export function updateExerciseTemplate(id, payload) {
    return axios.put('/api/exercisetemplates/' + id, JSON.stringify(payload), jsonHeaders);
}

export function deleteExerciseTemplate(id) {
    return axios.delete('/api/exercisetemplates/' + id, jsonHeaders);
}

// --- ExerciseTemplateElement (static blocks) ---

export function getElements(exerciseId) {
    return axios.get('/api/exercisetemplateelements?exercise=' + exerciseId, { withCredentials: true });
}

export function createElement(payload) {
    return axios.post('/api/exercisetemplateelements', JSON.stringify(payload), jsonHeaders);
}

export function updateElement(id, payload) {
    return axios.put('/api/exercisetemplateelements/' + id, JSON.stringify(payload), jsonHeaders);
}

export function deleteElement(id) {
    return axios.delete('/api/exercisetemplateelements/' + id, jsonHeaders);
}

// --- ExerciseTemplateInteractiveElement (interactive blocks) ---

export function getInteractiveElements(exerciseId) {
    return axios.get('/api/exercisetemplateinteractiveelements?exercise=' + exerciseId, { withCredentials: true });
}

export function createInteractiveElement(payload) {
    return axios.post('/api/exercisetemplateinteractiveelements', JSON.stringify(payload), jsonHeaders);
}

export function updateInteractiveElement(id, payload) {
    return axios.put('/api/exercisetemplateinteractiveelements/' + id, JSON.stringify(payload), jsonHeaders);
}

export function deleteInteractiveElement(id) {
    return axios.delete('/api/exercisetemplateinteractiveelements/' + id, jsonHeaders);
}

// --- ExerciseTemplateContainer (layout regions) ---

export function getContainers(exerciseId) {
    return axios.get('/api/exercisetemplatecontainers?exercise=' + exerciseId, { withCredentials: true });
}

export function createContainer(payload) {
    return axios.post('/api/exercisetemplatecontainers', JSON.stringify(payload), jsonHeaders);
}

export function updateContainer(id, payload) {
    return axios.put('/api/exercisetemplatecontainers/' + id, JSON.stringify(payload), jsonHeaders);
}

export function deleteContainer(id) {
    return axios.delete('/api/exercisetemplatecontainers/' + id, jsonHeaders);
}

// --- ExerciseTemplateWord (linked vocabulary) ---

export function getExerciseWords(exerciseId) {
    return axios.get('/api/exercisetemplatewords?exercise=' + exerciseId, { withCredentials: true });
}

export function createExerciseWord(exerciseTemplateId, wordId) {
    const payload = { exerciseTemplate: String(exerciseTemplateId), word: String(wordId) };
    return axios.post('/api/exercisetemplatewords', JSON.stringify(payload), jsonHeaders);
}

export function deleteExerciseWord(id) {
    return axios.delete('/api/exercisetemplatewords/' + id, jsonHeaders);
}

// --- shared lookups ---

export function getLevels() {
    return axios.get('/api/levels', { withCredentials: true });
}

// ExerciseTemplate.classification/.type point at dedicated exercise-scoped
// lookup tables (not the shared Clasification entity used elsewhere in the
// CRM) - contract change from the backend session, 2026-08-15.
export function getExerciseClassifications() {
    return axios.get('/api/exerciseclassifications', { withCredentials: true });
}
